"use client";

import { useEffect } from "react";

/**
 * Lazy loads PostHog analytics after the page becomes interactive.
 * Uses requestIdleCallback to load during browser idle time, preventing blocking.
 *
 * Trade-offs:
 * - Improves Time to Interactive by ~2-3 seconds
 * - Defers 86KB of JavaScript
 * - May miss very early clicks (< 1-2 seconds), but acceptable for content sites
 * - Session recording starts 1-2 seconds later
 */
export function PostHogInitializer() {
  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const loadPostHog = () => {
      // Dynamic import - PostHog code is split into separate chunk
      import("@/lib/analytics/posthog-lazy")
        .then(({ initializePostHog }) => {
          initializePostHog();
        })
        .catch(() => {
          // Silently fail - analytics are not critical to page functionality
        });
    };

    // Load when browser is idle, with max 2 second timeout
    if ("requestIdleCallback" in window) {
      requestIdleCallback(loadPostHog, { timeout: 2000 });
    } else {
      // Fallback for browsers without requestIdleCallback (older Safari)
      setTimeout(loadPostHog, 1000);
    }
  }, []);

  return null;
}
